import type { Components } from '@mui/material/styles';

export default function MUICardMedia(): Components['MuiCardMedia'] {
  return {};
}
